import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { lazyLoadSignatureInUserOptions } from 'owa-options-message-options';

export interface InitializeSignatureContentState {
    editorViewState: EditorViewState;
    userOptions: UserOptionsType;
}

export default select<InitializeSignatureContentState>({
    editorViewState: () => store.editorViewState,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('initializeSignatureContent')(async function initializeSignatureContent(
        state?: InitializeSignatureContentState
    ) {
        let { editorViewState, userOptions } = state;
        await lazyLoadSignatureInUserOptions.importAndExecute();
        editorViewState.content = userOptions.SignatureHtml;
    })
);
